exports.components = {
  "component---src-pages-contentful-page-url-js": () => import("./../../../src/pages/{contentfulPage.url}.js" /* webpackChunkName: "component---src-pages-contentful-page-url-js" */),
  "component---src-templates-portfolio-post-js": () => import("./../../../src/templates/portfolio-post.js" /* webpackChunkName: "component---src-templates-portfolio-post-js" */)
}

